<template>
  <p class="is-marginless result-count">
    Showing
    <i v-if="isLoading" class="fas fa-sync fa-spin"></i>
    <template v-else>{{totalResultCount}}</template>
    {{pluralize('hackathon', totalResultCount)}}
  </p>
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';

  import pluralize from '@/scripts/pluralize';

  export default {
    name: "ResultCount",

    setup() {
      const store = useStore();

      return {
        totalResultCount: computed(() => store.getters["hackathons/totalResultCount"]),

        isLoading: computed(() => store.getters["hackathons/isLoading"]),

        pluralize
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'colors';

  .result-count {
    color: $blue-grey-5;
  }
</style>
